import styled from '@emotion/styled'
import { Stack, Theme } from '@mui/material'

export const Container = styled(Stack)`
  gap: 10px;
  height: 100%;
`

export const EmptyStateWrapper = styled(Stack)`
  gap: 8px;
  flex-direction: row;
  align-items: center;
`

export const InnerItemContainer = styled(Stack)`
  padding: 8px;
  gap: 10px;
`

export const cardTitleStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '50px',
}

export const textBoxWrapper = {
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
}

export const cardTitleTypography = {
  marginLeft: '20px',
  fontSize: '1.3rem',
  fontWeight: 600,
  flexShrink: 0,
}

export const cardSubtitle = {
  fontSize: '16px',
  fontWeight: 600,
  textOverflow: 'ellipsis',
}

export const mainGrid = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
}

export const noDedliveriesTypography = {
  fontSize: '14px',
}

export const listInnerBox = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  borderRadius: '10px',
  border: (theme: Theme) => `2px solid ${theme.palette.grey[300]}`,
  backgroundColor: (theme: Theme) => `${theme.palette.grey[300]}`,
  width: '100%',
  minWidth: '100%',
  height: '50px',
  alignItems: 'center',
  paddingRight: '10px',
  paddingLeft: '10px',
  cursor: 'pointer',
}

export const flourDataMainWrapper = {
  width: '100%',
  height: '100%',
  gap: 1,
}

export const flourListWrapper = {
  msOverflowY: 'auto',
  maxHeight: '100%',
}

export const flourDetailsWrapper = {
  flexDirection: 'column',
  display: 'flex',
}

export const flourListGrid = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
}

export const flourListUpperGrid = {
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
}

export const FlourListActionBox = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '15px',
}

export const flourListTableBox = {
  flex: 1,
  overflowY: 'auto',
  margin: '0 15px',
  position: 'relative',
  minHeight: 0,
}

export const flourDeliveryListBox = {
  minWidth: '100%',
  overflow: 'hidden',
}

export const analysisContainer = {
  gap: 1,
  overflow: 'auto',
}

export const analysisWrapper = {
  gap: 1,
  overflow: 'auto',
}

export const analysisStatusSection = {
  gap: 1,
  flexDirection: 'row',
}

export const analysisStatusSectionContainer = {
  backgroundColor: '#fff',
  overflow: 'auto',
  minHeight: 250,
  flexDirection: 'column',
}

export const sectionContainer = {
  backgroundColor: '#fff',
  flexDirection: 'column',
  minHeight: 0,
  width: '100%',
}

export const expandableBox = {
  overflowY: 'auto',
}

export const insightRecommendationSectionContainer = {
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '10px',
  width: '100%',
  boxSizing: 'border-box',
}

export const insightRecommendationBox = {
  border: '1px solid',
  borderColor: 'grey.300',
  borderRadius: 1,
  p: 2,
  position: 'relative',
  transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
  maxWidth: 310,
  width: '100%',
  boxSizing: 'border-box',
  margin: '0 auto',
  '&:hover': {
    borderColor: 'grey.400',
    backgroundColor: (theme) => theme.palette.action.hover,
    boxShadow: 1,
  },
  '&:hover .card-actions': {
    opacity: 1,
  },
}

export const insightRecommendationBoxHover = {
  position: 'absolute',
  bottom: '5%',
  right: 8,
  display: 'flex',
  flexDirection: 'row',
  gap: 1.5,
  opacity: 0,
  transition: 'opacity 0.2s ease',
  pointerEvents: 'none',
  zIndex: 1,
}

export const insightRecommendationHoverIcon = {
  pointerEvents: 'auto',
  height: 25,
  width: 25,
  backgroundColor: (theme) => theme.palette.primary.main,
  '&:hover': {
    transform: 'scale(1.08)',
    backgroundColor: (theme) => theme.palette.primary.dark,
  },
}

export const roundedIconColor = {
  color: '#fff',
  height: '20px',
  width: '20px',
}

export const titleTypography = {
  fontWeight: 800,
}

export const subTitleTypography = {
  fontWeight: 400,
}

export const attributesSectionContainer = {
  flexDirection: 'row',
  flex: 1,
  flexWrap: 'wrap',
  height: '100%',
  gap: 1,
  overflow: 'auto',
}

export const discardButtonStack = {
  width: '250px',
}
